// extracted by mini-css-extract-plugin
export var blink = "SketchCode-module--blink--jowSg";
export var code = "SketchCode-module--code--Jc-Um";
export var folded = "SketchCode-module--folded--53bpG";
export var interactive = "SketchCode-module--interactive--NjeUA";
export var line = "SketchCode-module--line--1AJMI";
export var num = "SketchCode-module--num--WdWXq";
export var numBar = "SketchCode-module--numBar--Or+zV";
export var reset = "SketchCode-module--reset--Ei+pc";
export var root = "SketchCode-module--root---eJEZ";